import { Injectable, inject } from '@angular/core';
import {
  Resolve,
} from '@angular/router';
import { Observable } from 'rxjs';
import { ProfileService } from '../services/profile.service';
import { IPermission } from '../interfaces/permission.interface';

@Injectable({
  providedIn: 'root',
})
export class PermissionRoleResolver implements Resolve<IPermission[]> {
  private readonly profileService: ProfileService = inject(ProfileService);

  resolve(): Observable<IPermission[]> {
    return this.profileService.getPermissionsProfile();
  }
}
